import { Text } from '@ksyos/design-system';

interface ITooV1ProcedureAddEditOdOsLabel {
    data: string | null;
    units?: string;
}

export function TooV1ProcedureReadOdOsDataField({ data, units }: ITooV1ProcedureAddEditOdOsLabel) {
    return <Text size="xs"> {`${data} ${units ? units : ''}`}</Text>;
}
